import { CalculatorPageState } from "./models/CalculatorPageState";
import { PayloadAction } from "@reduxjs/toolkit";
import { AppContext } from "../../app/slices/models/appContext";
import { RangeValue } from "../../api/models/RangeValue";
import { validate } from "./calculatorValidations";
import { getOrCreateAbortController } from "./calculatorAsyncActions";

export const loadPage = (state: CalculatorPageState, _action: PayloadAction<AppContext>) => {
  state.isLoaded = true;
};

const getResidualValueRange = (state: CalculatorPageState): RangeValue | void => {
  if (
    !state.form.contractPeriodInMonths ||
    !state.financingStructure?.availableContractLengths ||
    state.financingStructure.availableContractLengths.length === 0
  ) {
    return;
  }

  const selectedContractLengthInMonths = state.financingStructure.availableContractLengths.find((x) => x.monthsFrom === state.form.contractPeriodInMonths);

  return selectedContractLengthInMonths?.residualValueRange;
};

export const applyContractPeriodChange = (state: CalculatorPageState) => {
  const residualValueRange = getResidualValueRange(state);
  if (!residualValueRange) {
    return;
  }

  const availableResidualPercentageValues = [];
  for (let i = residualValueRange.rangeFrom; i <= residualValueRange.rangeTo; i += residualValueRange.allowedSteps) {
    availableResidualPercentageValues.push(i);
  }
  state.availableResidualPercentageValues = availableResidualPercentageValues;
  state.form.residualValuePercentage = residualValueRange.defaultValue;
  state.form.recommendedResidualValuePercentage = residualValueRange.defaultValue;
};

export const updateForm = (state: CalculatorPageState, action: PayloadAction<{ name: string; value: string | number | null }>) => {
  const { name, value } = action.payload;
  state.form[name] = value;
  if (name === "contractPeriodInMonths") {
    applyContractPeriodChange(state);
  }
  validate(state);
  state.form.dirty = true;
};

export const validateForm = (state: CalculatorPageState) => {
  validate(state);
};

export const resetCalculatedValues = (state: CalculatorPageState) => {
  delete state.form.periodFee;
  getOrCreateAbortController("fetchPeriodFee")?.abort();
  state.form.loadingPeriodFee = false;
  delete state.form.loadingPeriodFeeError;
};

export const setPeriodFeeLoading = (state: CalculatorPageState, action: PayloadAction<boolean>) => {
  state.form.loadingPeriodFee = action.payload;
};

export const complete = (state: CalculatorPageState) => {
  state.isCompleted = true;
};
